import { PostHog } from "posthog-js";
import {
  sanitizeTraits,
  sanitizeEventProps,
  normalizeEventName,
  shouldBlockAnalytics,
} from "./sanitize";

export interface AnalyticsTraits {
  [key: string]: unknown;
}
export interface AnalyticsEventProps {
  [key: string]: unknown;
}

export interface AnalyticsClient {
  identify: (userId: string, traits?: AnalyticsTraits) => void;
  track: (event: string, props?: AnalyticsEventProps) => void;
  flush?: () => Promise<void>;
}

class CombinedAnalytics implements AnalyticsClient {
  constructor(private posthog: PostHog | null) {}

  identify(userId: string, traits?: AnalyticsTraits) {
    try {
      if (shouldBlockAnalytics()) return;
      const safeTraits = sanitizeTraits(
        traits as Record<string, unknown> | undefined,
      );
      if (this.posthog && safeTraits) {
        this.posthog.identify(userId, safeTraits);
      }
    } catch (e) {
      console.warn("[Analytics] identify failed", e);
    }
  }

  track(event: string, props?: AnalyticsEventProps) {
    try {
      if (shouldBlockAnalytics()) return;
      const name = normalizeEventName(event);
      const safeProps = sanitizeEventProps(
        props as Record<string, unknown> | undefined,
      );
      if (this.posthog) {
        this.posthog.capture(name, safeProps);
      }
    } catch (e) {
      console.warn("[Analytics] track failed", e);
    }
  }

  async flush() {
    // Langfuse removed - now PostHog only
    try {
      // No-op: PostHog auto-flushes
    } catch {
      /* noop */
    }
  }
}

export function createAnalytics(posthog: PostHog | null): AnalyticsClient {
  return new CombinedAnalytics(posthog);
}
